import { createContext, useContext } from "react";
import type { AuthenticateResult } from "./oktaClient";

export interface AuthState extends AuthenticateResult {
  loading: boolean;
}

export const AuthContext = createContext<AuthState>({
  authenticated: false,
  loading: true,
});

export function useAuth(): AuthState {
  return useContext(AuthContext);
}
